export enum MapType {
  roadmap = 'roadmap',
  satelite = 'satelite',
  hybrid = 'hybrid',
  terrain = 'terrain',
}

// ROADMAP (normal, default 2D map)
// SATELLITE (photographic map)
// HYBRID (photographic map + roads and city names)
// TERRAIN (map with mountains, rivers, etc.)
